export default __webpack_public_path__ + "static/image12-bd40cabbcced73b4987a0b445a979df5.jpg";